export interface Bonus {
  number: string
  title: string
  tagline: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Mappa Rapida di Decisione',
    tagline:
      'Scegli la sessione corretta in meno di 5 minuti rispondendo a 4 domande: obiettivo, tempo, livello e spazio.',
    image:
      'https://cdn.magicpatterns.com/uploads/mhfeB5jWoqxbEXyVXhSpvb/mockup-mapa-rapido-de-decision.webp',
    alt: "Copertina del Bonus 1: Mappa rapida di decisione, con un allenatore e il suo gruppo in pista.",
  },
  {
    number: '2',
    title: 'Correzioni Express',
    tagline: '40 errori tecnici comuni e la frase esatta per correggerli.',
    image:
      'https://cdn.magicpatterns.com/uploads/522sEoGZQ7TtrqugtuYZZR/mockup-manual-de-correcciones-express.webp',
    alt: 'Copertina del Bonus 2: Correzioni express, con un velocista in piena accelerazione.',
  },
  {
    number: '3',
    title: 'Adattamento Gruppi Misti',
    tagline:
      'Una sessione in 3 livelli: Base, Sviluppo e Performance. Nessun atleta inattivo.',
    image:
      'https://cdn.magicpatterns.com/uploads/oxhPhwZWHbFFNWfK4w7JnS/mockup-guia-de-adaptacion-para-grupos-mixtos.webp',
    alt: 'Copertina del Bonus 3: Adattamento gruppi misti, con coni sulla pista al tramonto.',
  },
  {
    number: '4',
    title: 'Riscaldamenti Specifici',
    tagline:
      '8 protocolli per disciplina, in versione corta (10 min) e completa (20 min).',
    image:
      'https://cdn.magicpatterns.com/uploads/wFPhzwD4eSwRxek42u9XB7/mockup-protocolos-de-calentamiento-especifico.webp',
    alt: 'Copertina del Bonus 4: Riscaldamenti specifici, con un atleta in posizione di partenza.',
  },
  {
    number: '5',
    title: 'Biblioteca di Consegne Tecniche',
    tagline: '50+ “cue” verbali per cambiamenti tecnici immediati.',
    image:
      'https://cdn.magicpatterns.com/uploads/27aTBmcr4fu2Tx512q3aXb/mockup-biblioteca-de-consignas-tecnicas.webp',
    alt: 'Copertina del Bonus 5: Biblioteca di consegne tecniche, con blocchi di partenza sulla pista.',
  },
]

/** Riepilogo breve usato nella tabella del valore. */
export const bonusValueRows: { label: string; value: string }[] = [
  { label: 'Bonus 1 — Mappa di Decisione', value: '€19' },
  { label: 'Bonus 2 — Correzioni Express', value: '€17' },
  { label: 'Bonus 3 — Adattamento Gruppi Misti', value: '€15' },
  { label: 'Bonus 4 — Riscaldamenti Specifici', value: '€14' },
  { label: 'Bonus 5 — Consegne Tecniche', value: '€12' },
]
